<template>
    <v-main class="crm-layout">
        <crm-navigation-bar></crm-navigation-bar>

        <v-main class="pt-10 pb-12 mb-12">
            <v-container>
                <slot></slot>
            </v-container>
        </v-main>    
    </v-main>
</template>

<script>
import CrmNavigationBar from '@/components/navigation/CrmNavigationBar'

export default {
    name: 'CrmLayout',
    components: {
        CrmNavigationBar
    }
}
</script>

<style scoped>
.crm-layout {
    background-color: #f0f0f0;
}
</style>